<template>
    <div style="text-align:left">
        <br>
        <div class="taxonomy-label">{{$t('labels.order')}}</div>
        <v-btn 
            @click.native="showOrderDialog=true"
            class="select-taxonomy-button"
            style="margin-left:0"
        > 
            <span v-if="selectedOrder">
                {{selectedOrder.order}}
            </span>
            <span v-else>
                {{$t('labels.choose')}}...
            </span>
        </v-btn><br>
        <!-- SUBORDER -->
        <div class="taxonomy-label">{{$t('labels.underOrderGrouping')}}</div>
        <v-btn 
            @click.native="showSuborderDialog=true"
            class="select-taxonomy-button"
            style="margin-left:0"
            :disabled="selectedOrder===null"
        > 
            <span v-if="selectedSuborder">
                <span v-if="selectedSuborder.suborder">{{selectedSuborder.suborder}}</span>
                <span v-else style="font-style:italic;"> {{$t('labels.none')}} </span>
            </span>
            <span v-else>
                {{$t('labels.choose')}}...
            </span>
        </v-btn><br>
        <!-- FAMILY -->
        <div class="taxonomy-label">{{$t('labels.family')}}</div>
        <v-btn 
            @click.native="showFamilyDialog=true"
            class="select-taxonomy-button"
            style="margin-left:0"
            :disabled="selectedSuborder===null"
        > 
            <span v-if="selectedFamily">
                {{selectedFamily.family}}
            </span>
            <span v-else>
                {{$t('labels.choose')}}...
            </span>
        </v-btn>
        <!-- GENUS -->
        <div class="taxonomy-label">{{$t('labels.genus')}}</div>
        <v-btn 
            @click.native="showGenusDialog=true"
            class="select-taxonomy-button"
            style="margin-left:0"
            :disabled="selectedFamily===null"
        > 
            <span v-if="selectedGenus" style="font-style:italic">
                {{selectedGenus.genus}}
            </span>
            <span v-else>
                {{$t('labels.choose')}}...
            </span>
        </v-btn>
        <!-- ORDER DIALOG -->
        <v-dialog
                v-model="showOrderDialog"
                width="500"
            >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.selectOrder')}}
                </v-card-title>
                <v-card-text>
                    <v-card 
                        class="taxonomy-for-picker"
                        v-for="order in taxonomyTree" :key="order.order" 
                        @click="orderClicked(order)"
                    >
                        <v-card-text>
                            <div class="inline-block" style="max-width: calc(100% - 70px);">
                                {{order.order}}
                            </div>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showOrderDialog = false"
                >
                    {{$t('labels.cancel')}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- SUBORDER DIALOG -->
        <v-dialog
                v-model="showSuborderDialog"
                width="500"
                v-if="selectedOrder"
            >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.selectUnderOrderGrouping')}}
                </v-card-title>
                <v-card-text>
                    <v-card 
                        class="taxonomy-for-picker"
                        v-for="suborder in selectedOrder['suborders']" :key="suborder.suborder" 
                        @click="suborderClicked(suborder)"
                    >
                        <v-card-text>
                            <div class="inline-block" style="max-width: calc(100% - 70px);">
                                <span v-if="suborder.suborder">{{suborder.suborder}}</span>
                                <span v-else style="font-style:italic;"> {{$t('labels.none')}} </span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showSuborderDialog = false"
                >
                    {{$t('labels.cancel')}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- FAMILY DIALOG -->
        <v-dialog
            v-model="showFamilyDialog"
            width="500"
            v-if="selectedSuborder"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.selectFamily')}}
                </v-card-title>
                <v-card-text>
                    <v-card 
                        class="taxonomy-for-picker"
                        v-for="family in selectedSuborder['families']" :key="family.family" 
                        @click="familyClicked(family)"
                    >
                        <v-card-text>
                            <div class="inline-block" style="max-width: calc(100% - 70px);">
                                {{family.family}}
                            </div>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showFamilyDialog = false"
                >
                    {{$t('labels.cancel')}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- GENUS DIALOG -->
        <v-dialog
            v-model="showGenusDialog"
            width="500"
            v-if="selectedFamily"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.selectGenus')}}
                </v-card-title>
                <v-card-text>
                    <v-card 
                        class="taxonomy-for-picker"
                        v-for="genus in selectedFamily['genera']" :key="genus.genus" 
                        @click="genusClicked(genus)"
                    >
                        <v-card-text>
                            <div class="inline-block" style="max-width: calc(100% - 70px);font-style: italic;">
                                {{genus.genus}}
                            </div>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showGenusDialog = false"
                >
                    {{$t('labels.cancel')}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
const axios = require('axios').default;
export default {
  name: "SelectTaxonomy",
  props: ["value"],
  data() {
    return {
        showOrderDialog: false,
        showSuborderDialog: false,
        showFamilyDialog: false,
        showGenusDialog: false,
        selectedOrder: null,
        selectedSuborder: null,
        selectedFamily: null,
        selectedGenus: null,
        taxonomyTree:{}
    };
  },
  methods: {
    async getTaxonomyTree(){
        let vm = this;
        try {
            const response = await axios({
                method: "GET",
                url: vm.$API_BASE_URL + "taxonomy/get.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            });
            if (response.status == 200) {
                vm.taxonomyTree = response.data.resources;
            } 
            else{
                alert(vm.$t('labels.errorLoading'));
            }
        } catch(error) {
            if(error.response && (error.response.status==403||error.response.status==401)){
                vm.$router.push({name: 'login'});
            }
            else{
                alert(vm.$t('labels.errorLoading'));
                console.error(error)
            }
        }
    },
    orderClicked(order){
        let vm = this;
        vm.selectedOrder = order;
        vm.selectedSuborder = null;
        vm.selectedFamily = null;
        vm.selectedGenus = null;
        vm.showOrderDialog = false;
        vm.$emit("input", {
            "order":vm.selectedOrder.order,
            "suborder": null,
            "family":null,
            "genus":null
        });
    },
    suborderClicked(suborder){
        let vm = this;
        vm.selectedSuborder = suborder;
        vm.selectedFamily = null;
        vm.selectedGenus = null;
        vm.showSuborderDialog = false;
        vm.$emit("input", {
            "order":vm.selectedOrder.order,
            "suborder":vm.selectedSuborder.suborder,
            "family":null,
            "genus":null
        });
    },
    familyClicked(family){
        let vm = this;
        vm.selectedFamily = family;
        vm.selectedGenus = null;
        vm.showFamilyDialog = false;
        vm.$emit("input", {
            "order":vm.selectedOrder.order,
            "suborder":vm.selectedSuborder.suborder,
            "family":vm.selectedFamily.family,
            "genus":null
        });
    },
    genusClicked(genus){
        let vm = this;
        vm.selectedGenus = genus;
        vm.showGenusDialog = false;
        vm.$emit("input", {
            "order":vm.selectedOrder.order,
            "suborder":vm.selectedSuborder.suborder,
            "family":vm.selectedFamily.family,
            "genus":vm.selectedGenus.genus
        });
    }
  },
  mounted() {
    let vm = this;
    vm.getTaxonomyTree();
  },
  watch: {
    value: {
      handler: function (newValue) {
        let vm = this;
        vm.selectedValue=newValue;
      },
      immediate: true,
    }
  },
};
</script>

<style>
    .cardbutton .v-btn__content{
        display:block!important;
        text-align: left;
    }
    .cardbutton{
        padding: 30px 20px;
    }
    .v-card.taxonomy-for-picker{
        margin-bottom:5px;
    }
    .select-taxonomy-button.v-btn {
        text-align: left;
        padding: 25px 10px 25px 10px;
        text-transform: none;
        min-width:200px;
        margin-bottom:20px;
    }
    .taxonomy-label{
        font-size:16px;
    }
</style>
